module.exports = __webpack_public_path__ + "static/img/6.a1b96aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/6.png
// module id = qliV
// module chunks = 0